import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import { ProfileInfo } from "../../components/ProfileInfo";
import { Students } from "../../components/Students";
import { TabsComponent } from "../../components/TabsComponent";

export const ProfilePage = ({ user, userRole }) => {
  const [tabs] = useState([
    { id: 1, name: "Info" },
    ...(userRole === "Teacher" || userRole === "Guardian"
      ? [
          { id: 2, name: userRole === "Teacher" ? "Students" : "Childs" },
          { id: 3, name: "Subscriptions" },
        ]
      : []),
  ]);

  return (
    <TabsComponent
      tabList={tabs}
      tabPanels={[
        {
          panel: <ProfileInfo user={user} isTeacher={userRole === "Teacher"} />,
        },
        {
          panel: (
            <Students
              user={user}
              userRole={userRole}
              isTeacher={userRole === "Teacher"}
            />
          ),
        },
        {
          panel: (
            <Box
              style={{
                maxWidth: "1180px",
                margin: "0 auto",
                padding: "30px 20px",
              }}
            >
              Coming soon!
            </Box>
          ),
        },
      ]}
    />
  );
};
